import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { RowContainer, Typography } from '..';
import IconComponent from '../../Icon';

export const Back = ({ children, to }) => {
    const router = useHistory();

    if (!to) {
        return (
            <RowContainer spacing="medium" className="mb-6">
                <RowContainer
                    spacing="medium"
                    className="cursor-pointer items-center"
                    onClick={() => router.goBack()}
                >
                    <IconComponent
                        icon="chevron"
                        height={14}
                        width={14}
                        rotate={90}
                        colour="text-grey-dark"
                    />
                    <Typography variant="heading3.2" color="grey-dark">
                        {children ? children : 'Back'}
                    </Typography>
                </RowContainer>
            </RowContainer>
        );
    }

    return (
        <RowContainer spacing="medium" className="items-center mb-6">
            <Link className="flex items-center gap-x-4" to={to}>
                <IconComponent
                    icon="chevron"
                    height={14}
                    width={14}
                    rotate={90}
                    colour="text-grey-dark"
                />
                <Typography variant="heading3.2" color="grey-dark">
                    {children ? children : 'Back'}
                </Typography>
            </Link>
        </RowContainer>
    );
};
